import { useAppSelector } from '@/renderer/hooks/useRedux';
import { selectEffectiveOutletId } from '@/renderer/store/outlets';
import React from 'react';

interface OutletIndicatorProps {
  description?: string;
}

export const OutletIndicator: React.FC<OutletIndicatorProps> = ({
  description = 'Viewing records across all outlets.',
}) => {
  const outletId = useAppSelector(selectEffectiveOutletId);

  if (outletId) return null;

  return (
    <div className="rounded-2xl border border-primary/50 bg-green-50 p-2 text-sm text-green-700">
      {description}
    </div>
  );
};
